import React from 'react';
import { useSelector } from 'react-redux';
import { selectUser } from '../../reducers/auth/authSlice';
import MessageMedia from '../chat/Message/MessageMedia';
import { Avatar, Box, Tooltip, Typography } from '@mui/material';
import moment from 'moment';

export default function HelpCenterMessage({ message, chat, index }) {

  const currentLoginUser = useSelector(selectUser);

  const isMe = () => {
    return currentLoginUser._id === message.sender;
  };

  const formatTimestamp = (timestamp) => {
    return moment(timestamp).format('MMM DD [AT] HH:mm');
  };

  const formatTime = (timestamp) => {
    return moment(timestamp).format('HH:mm');
  };
   
  const shouldShowDate = () => {
    if (index === 0) return true; // Show date for the first message
    const messages = chat.messages;

    const currentMessageDate = new Date(messages[index].createdAt).toDateString();
    const previousMessageDate = new Date(messages[index - 1].createdAt).toDateString();

    return currentMessageDate !== previousMessageDate;
  };
   
  const shouldShowTime = () => {
    if (index === 0) return false; 
    const messages = chat.messages;
    const currentMessageDate = formatTime(messages[index].createdAt);
    const previousMessageDate = formatTime(messages[index - 1].createdAt);

    return currentMessageDate !== previousMessageDate;
  };

  return (
    <>

      {
        shouldShowDate(index) && <Typography
          variant='caption' 
          fontSize={10} 
          display={'block'} 
          textAlign={'center'}
          mb={1}
        >
          {formatTimestamp(message.createdAt).toUpperCase()}
        </Typography>
      }

      {
        !shouldShowDate(index) && shouldShowTime(index) && <Typography 
          variant='caption'
          fontSize={10}
          color={'gray'} 
          display={'block'}
          textAlign={'center'}
        >
          {formatTime(message.createdAt)}
        </Typography>
      }

      <Box
        key={message._id}
        display={'flex'}
        pr={2}
        justifyContent={isMe() ? 'end' : ''}
      >
        <Box>

          <Tooltip arrow title={moment(message.createdAt).fromNow()}>
            <Box ml={2} bgcolor={'white'} p={1}>
              <Typography
                variant='body2' 
                display={'flex'} 
                justifyContent={isMe() ? 'end' : ''}
              >
                {message.content}
              </Typography>

              <Box width={200} mt={0.5}>
                <MessageMedia media={message.media} />
              </Box>
            </Box>
          </Tooltip>
          
          {
            message.sender === '6680f6afc2b6636dd2aee833' && <Tooltip arrow title='LeavesSupport'>
              <Avatar 
                src='http://localhost:3000/static/media/logo.a021d0c8fa34c60e04c1.jpg' 
                alt='leavesSupport'
                sx={{ width: 30, height: 30, mt: -0.2 }}
              />
            </Tooltip>
          }
        </Box>
      </Box>
    </>
  );
}
